const img = (id, w = 1000) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?auto=format&fit=crop&w=1920&q=85',
  founder: img('photo-1633775218380-30c7ab85a5c5', 900),
  aboutSecondary: 'https://images.unsplash.com/photo-1737682599438-319b61711b5f?auto=format&fit=crop&w=900&q=80',
};

export const STATS = [
  { value: 1000, suffix: '+', label: 'Events Executed' },
  { value: 100, suffix: '+', label: '5-Star Reviews' },
  { value: 2, suffix: '', label: 'Industry Awards' },
  { value: 4500, suffix: '+', label: 'Instagram Followers' },
];

export const SERVICES = [
  {
    title: 'Weddings',
    slug: 'weddings',
    image: img('photo-1469371670807-013ccf25f16a'),
    description: 'Planning, theme decor, photography, entertainment, catering, light & sound and complete execution — your big day, flawlessly handled.',
  },
  {
    title: 'Birthday Parties',
    slug: 'birthdays',
    image: img('photo-1755704282977-340323fa52df'),
    description: 'Kids birthdays, milestone celebrations and themed parties — customised end-to-end around the person you love.',
  },
  {
    title: 'Baby Showers & Cradle Ceremonies',
    slug: 'baby-showers',
    image: img('photo-1464349095431-e9a21285b5f3'),
    description: 'Elegant, personalised celebrations with decor, photography, entertainment and complete coordination.',
  },
  {
    title: 'Devotional Events',
    slug: 'devotional',
    image: img('photo-1470229722913-7c0e2dbbafd3'),
    description: 'Mata Ki Chowki, Bhajan Sandhya, Bhajan Jamming and spiritual gatherings — handled with reverence and care.',
  },
  {
    title: 'Corporate Events',
    slug: 'corporate',
    image: img('photo-1531058020387-3be344556be6'),
    description: 'Annual functions, launches, conferences and employee celebrations — professional, polished, on-brand.',
  },
  {
    title: 'School & Community Events',
    slug: 'community',
    image: img('photo-1509062522246-3755977927d7'),
    description: 'School functions, cultural programs, gated community events and Independence Day celebrations at any scale.',
  },
];

export const INDIVIDUAL_SERVICES = [
  'Event Planning', 'Theme Decoration', 'Photography', 'Videography', 'Light & Sound',
  'Entertainment', 'Catering', 'Logistics', 'Anchoring / Emceeing', 'Complete Event Management',
];

export const JOURNEY_STEPS = ['Plan', 'Design', 'Decor', 'Photography', 'Entertainment', 'Catering', 'Sound & Lighting', 'Logistics', 'Execute'];

export const PROCESS_STEPS = [
  { num: '01', title: 'Consult', text: 'Tell us about your event — your occasion, your people, your dreams.' },
  { num: '02', title: 'Plan', text: 'We understand your requirements and craft a complete event plan.' },
  { num: '03', title: 'Design', text: 'We create the theme, the decor and the overall experience.' },
  { num: '04', title: 'Execute', text: 'Our team handles every detail, every vendor, every moment.' },
  { num: '05', title: 'Celebrate', text: 'You simply enjoy your event. We take care of everything else.' },
];

export const WHY_POINTS = [
  { title: 'End-to-End Execution', text: 'From the first concept to the final farewell — we manage everything, so you never chase a vendor.' },
  { title: 'Creative Concepts', text: 'No templates. Every event is designed around your story, your taste and your budget.' },
  { title: 'Professional Execution', text: 'An experienced core team and a trusted vendor network that shows up and delivers, every time.' },
  { title: 'One-Point Coordination', text: 'One team, one call, one point of contact. Complete peace of mind from start to finish.' },
  { title: 'Award-Winning Experience', text: 'Recognised as Best Event Planner in Telangana (TAA 2024) and Best Event Planner of Hyderabad (Brands of India 2025).' },
  { title: '1000+ Events', text: 'Over a thousand celebrations delivered across Hyderabad and Telangana — experience you can trust.' },
];

export const AWARDS = [
  { year: '2025', title: 'Best Event Planner of Hyderabad', org: 'Brands of India' },
  { year: '2024', title: 'Best Event Planner in Telangana', org: 'TAA — Telangana Artists Association' },
];

export const TESTIMONIALS = [
  {
    name: 'Sravani & Kiran',
    event: 'Wedding, Hyderabad',
    initials: 'SK',
    review: 'AJ and his team turned our wedding into something out of a dream. Every ritual, every detail, every transition was seamless. Our families still talk about it.',
  },
  {
    name: 'Ramesh Gupta',
    event: 'Mata Ki Chowki, Secunderabad',
    initials: 'RG',
    review: 'The devotional evening was organised with so much bhakti and discipline. Sound, decor, seating — everything was perfect. Truly a divine experience.',
  },
  {
    name: 'Priya Sharma',
    event: 'Twin Birthday Celebration',
    initials: 'PS',
    review: 'They planned my twins\u2019 birthday down to the smallest detail. The theme, the games, the cake moment — the kids were overjoyed and we just enjoyed the day.',
  },
  {
    name: 'Vikram Reddy',
    event: 'Corporate Annual Day',
    initials: 'VR',
    review: 'Professional, punctual and creative. Our annual day ran like clockwork and the stage design exceeded expectations. Highly recommended for corporate events.',
  },
  {
    name: 'Anitha & Suresh',
    event: 'Baby Shower, Hyderabad',
    initials: 'AS',
    review: 'Such a warm, elegant celebration. The decor was beautiful and the team made our families feel completely at ease. Memories we will cherish forever.',
  },
];

export const PORTFOLIO_CATEGORIES = [
  'All', 'Weddings', 'Birthdays', 'Baby Showers', 'Cradle Ceremonies', 'Devotional', 'Corporate', 'Community', 'School Events',
];

// Placeholder imagery until real event photos/videos are provided.
// Video entries support YouTube, YouTube Shorts and Instagram Reels URLs — platform is auto-detected.
export const PORTFOLIO_ITEMS = [
  {
    id: 'p1', type: 'image', category: 'Weddings',
    title: 'A Royal Telugu Wedding', location: 'Hyderabad',
    description: 'A grand celebration of tradition and elegance — full planning, decor and execution.',
    image: img('photo-1583939003579-730e3918a45a'),
  },
  {
    id: 'p2', type: 'video', category: 'Birthdays',
    title: 'Twin Birthday Celebration', location: 'Hyderabad',
    description: 'A double dose of joy — themed decor, games and a magical cake moment. Sample film placeholder; replace with your YouTube URL.',
    videoUrl: 'https://www.youtube.com/watch?v=LXb3EKWsInQ',
    image: '',
  },
  {
    id: 'p3', type: 'image', category: 'Weddings',
    title: 'The Chandelier Stage', location: 'Hyderabad',
    description: 'Reception stage design with cascading florals and warm chandelier light.',
    image: 'https://images.unsplash.com/photo-1708606811579-23b18fc48007?auto=format&fit=crop&w=1000&q=80',
  },
  {
    id: 'p4', type: 'image', category: 'Birthdays',
    title: 'Pastel First Birthday', location: 'Hyderabad',
    description: 'A soft pastel wonderland for a very special first birthday.',
    image: img('photo-1530103862676-de8c9debad1d'),
  },
  {
    id: 'p5', type: 'video', category: 'Weddings',
    title: 'Wedding Moments — Short', location: 'Hyderabad',
    description: 'A vertical highlight short from a recent celebration. Sample placeholder; replace with your YouTube Shorts URL.',
    videoUrl: 'https://www.youtube.com/shorts/jNQXAC9IVRw',
    image: '',
  },
  {
    id: 'p6', type: 'image', category: 'Devotional',
    title: 'Mata Ki Chowki', location: 'Secunderabad',
    description: 'An evening of bhajans and devotion, organised with reverence and care.',
    image: img('photo-1470229722913-7c0e2dbbafd3'),
  },
  {
    id: 'p7', type: 'image', category: 'Corporate',
    title: 'Annual Day Gala', location: 'Hyderabad',
    description: 'A premium corporate annual celebration — stage, sound, light and show-flow.',
    image: img('photo-1531058020387-3be344556be6'),
  },
  {
    id: 'p8', type: 'image', category: 'Baby Showers',
    title: 'A Sweet Welcome', location: 'Hyderabad',
    description: 'An elegant baby shower with dessert styling and delicate florals.',
    image: img('photo-1464349095431-e9a21285b5f3'),
  },
  {
    id: 'p9', type: 'image', category: 'Cradle Ceremonies',
    title: 'Cradle Ceremony in Bloom', location: 'Hyderabad',
    description: 'Floral cradle decor for a newborn\u2019s first celebration.',
    image: img('photo-1490750967868-88aa4486c946'),
  },
  {
    id: 'p10', type: 'video', category: 'Weddings',
    title: 'Celebration Reel', location: 'Hyderabad',
    description: 'Follow our latest reels on Instagram @eventsby_aj.',
    videoUrl: 'https://www.instagram.com/eventsby_aj/',
    image: img('photo-1519741497674-611481863552'),
  },
  {
    id: 'p11', type: 'image', category: 'Community',
    title: 'Community Dinner Night', location: 'Gated Community, Hyderabad',
    description: 'A gated-community celebration with live counters, music and games.',
    image: img('photo-1511795409834-ef04bbd61622'),
  },
  {
    id: 'p12', type: 'image', category: 'School Events',
    title: 'Annual School Fest', location: 'Hyderabad',
    description: 'Stage, sound and show management for a school annual day.',
    image: img('photo-1509062522246-3755977927d7'),
  },
  {
    id: 'p13', type: 'image', category: 'Corporate',
    title: 'Product Launch Night', location: 'Hyderabad',
    description: 'A high-energy launch with dramatic lighting and immersive staging.',
    image: img('photo-1505373877841-8d25f7d46678'),
  },
  {
    id: 'p14', type: 'image', category: 'Weddings',
    title: 'The Long Table Reception', location: 'Hyderabad',
    description: 'An intimate reception dinner under chandeliers and candlelight.',
    image: 'https://images.unsplash.com/photo-1737682599438-319b61711b5f?auto=format&fit=crop&w=1000&q=80',
  },
  {
    id: 'p15', type: 'image', category: 'Devotional',
    title: 'Bhajan Sandhya Under Lights', location: 'Hyderabad',
    description: 'A devotional evening with festive lighting and soulful music.',
    image: img('photo-1498931299472-f7a63a5a1cfa'),
  },
  {
    id: 'p16', type: 'image', category: 'Birthdays',
    title: 'Confetti Countdown', location: 'Hyderabad',
    description: 'A milestone birthday that ended in a storm of confetti.',
    image: img('photo-1513151233558-d860c5398176'),
  },
];
